import { constants } from "../../../constants";

export default class GameLoadEnd {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    GREENTUBE_handler(msg) {
        if (msg.event.value === 100) {
            // game client sends 2 identical msgs in span of a good second ... so ignoring anything that comes in the time window of 2 sec
            if (this.greentubeGameLoadEndEmitted === true) return;

            this.gb.emitters.emit.web.gameLoadEnd();
            this.greentubeGameLoadEndEmitted = true;
            setTimeout(() => {
                delete this.greentubeGameLoadEndEmitted;
            }, 2000);
        }
    }

    AMATIC_handler(msg) {
        if (msg.data && msg.data.success === true) {
            this.gb.emitters.emit.web.gameLoadEnd();
        } else {
            this.gb.emitters.emit.web.error(msg);
        }
    }

    NEXTGEN_handler(payload) {
        this.gb.eventOrigin = payload.origin;
        this.gb.eventSource = payload.source;

        this.gb.emitters.emit.web.gameLoadEnd();
    }

    EZUGI_handler(msg) {
        this.gb.emitters.emit.web.gameLoadEnd(msg.value);
    }

    EVOLUTION_handler(event) {
        if (event.source) {
            this.gb.evolutionSource = event.source;
            event.source.postMessage({
                command: "EVO:EVENT_SUBSCRIBE",
                event: "EVO:GAME_LIFECYCLE"
            }, "*");
        }

        if (event.data) {
            this.gb.emitters.emit.web.gameLoadEnd(event.data);
        }
    }

    EVO_handler(data) {
        if (data && data.data) {
            this.gb.emitters.emit.web.gameLoadEnd(data.data);
        } else {
            this.gb.emitters.emit.web.gameLoadEnd();
        }
    }

    DGC_handler(data) {
        this.gb.emitters.emit.web.gameLoadEnd();
    }

    QS_RELAX_handler(data) {
        this.gb.emitters.emit.web.gameLoadEnd(data);
    }

    SH_handler(payload) {
        if (payload && payload.value === 'ready') {
            this.gb.emitters.emit.web.gameLoadEnd(payload);
        }
    }

    RRG_handler(payload) {
        if (payload.data && payload.data.progress === "100") {
            this.gb.emitters.emit.web.gameLoadEnd();
        }
    }

    PUSH_handler(data) {
        this.gb.emitters.emit.web.gameLoadStart(data); // Push doesn't have an event for game load start, so an artificial one is added here.
        this.gb.emitters.emit.web.gameLoadEnd(data);
    }

    BOOMING_handler(data) {
        this.gb.emitters.emit.web.gameLoadStart(data); // BOOMING doesn't have an event for game load start, so an artificial one is added here.
        this.gb.emitters.emit.web.gameLoadEnd(data);
    }

    _default(data) {
        this.gb.emitters.emit.web.gameLoadEnd(data);
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.gameProviderProtocol) {
            case constants.GREENTUBE:
                event["loadingProgress"] = this.GREENTUBE_handler;
                break;
            case constants.PRAGMATIC_PLAY:
                event["gameLoadingEnded"] = this._default;
                break;
            case constants.F1X2:
                event["load-end"] = this._default;
                break;
            case constants.SLINGO:
                event["gameReady"] = this._default;
                event["gameLoaded"] = this._default;
                break;
            case constants.RELAX:
                event["gprg_Ready"] = this.QS_RELAX_handler;
                break;
            case constants.IGT:
                event["rgs2custGameInit"] = this._default;
                break;
            case constants.PNG:
                event["gameReady"] = this._default;
                break;
            case constants.NETE:
                event["gameReady"] = this._default;
                break;
            case constants.MGS:
                event["gameLoaded"] = this._default;
                break;
            case constants.NEXTGEN:
            case constants.NYXNEXTGEN:
                event["gameReady"] = this._default;
                event["gameRevealed"] = this.NEXTGEN_handler;
                break;
            case constants.THUNDER:
                event["gameinitialized"] = this._default;
                break;
            case constants.BP:
                event["gameReady"] = this._default;
                break;
            case constants.AMATIC:
                event["gameLoaded"] = this.AMATIC_handler;
                break;
            case constants.EDICT:
                event["gameLoadingEnded"] = this._default;
                break;
            case constants.EZUGI:
                event["game.start"] = this.EZUGI_handler;
                break;
            case constants.EVOLUTION:
                event["GAME_LOADED"] = this.EVO_handler;
                event["APPLICATION_READY"] = this.EVOLUTION_handler;
                break;
            case constants.STAKELOGIC2:
                event["LOAD_FINISH"] = this._default;
                break;
            // case constants.GSBINGO:
            //     event["gameReady"] = this._default;
            //     break;
            case constants.GSPOKER:
            case constants.BGS:
                event["loadEnd"] = this._default;
                break;
            case constants.RGU:
            case constants.RAW:
            case constants.HB:
                event["gameReady"] = this._default;
                break;
            case constants.DGC:
                event["gel.ready"] = this.DGC_handler;
                break;
            case constants.QS:
                event["gprg_Ready"] = this.QS_RELAX_handler;
                break;
            case constants.SH:
                event["game"] = this.SH_handler;
                break;
            case constants.RRG:
                event["GAME_LOADING"] = this.RRG_handler;
                event["GAME_LOADED"] = this._default;
                break;
            case constants.WD:
                event["WGEAPI.status.ready"] = this._default;
                break;
            case constants.HKS:
                event["onGameLoaded"] = this._default;
                break;
            case constants.SYN:
                event["g2p.gameReady"] = this._default;
                break;
            case constants.KAJ:
                event["game.loaded"] = this._default;
                break;
            case constants.DUSO:
                event["LOADED"] = this._default;
                break;
            case constants.ISOFT:
                event["GAME_READY"] = this._default;
                break;
            case constants.PT:
                event["ucip.loadingstatus.g2wLoadingEndNotification"] = this._default;
                break;
            case constants.NLC:
                event["ready"] = this._default;
                break;
            case constants.YGG:
                event["game/ready"] = this._default;
                break;
            case constants.HBN:
                // event["gameInit"] = this._default;
                event["gameReady"] = this._default;
                break;
            case constants.SPIN:
                event["loaded"] = this._default;
                event["game_ready"] = this._default;
                break;
            case constants.ENDOR:
                event["gameLoaded"] = this._default;
                break;
            case constants.PLS:
                event["loaded"] = this._default;
                break;
            case constants.GDR2:
                event["game.loaded"] = this._default;
                break;
            case constants.SPINOMENAL:
                event["gameLoadingEnd"] = this._default;
                break;
            case constants.EDIG:
                event["gameLoadComplete"] = this._default;
                break;
            case constants.EYE:
                event["gameReady"] = this._default;
                break;
            case constants.HNR:
                event["gameInit"] = this._default;
                event["gameReady"] = this._default;
                event["gameLoadingEnded"] = this._default;
                break;
            case constants.OAK:
                event["game_ready"] = this._default;
                break;
            case constants.BSFT:
                event["exi_onCurrencyInitialized"] = this._default;
                break;
            case constants.PUSH:
                event["gameReady"] = this.PUSH_handler;
                break;
            case constants.BOOMING:
                event["gameLoaded"] = this.BOOMING_handler;
                break;
            default:
                event["loadEnd"] = this._default;
                event["loadProcessEnd"] = this._default;
        }

        return event;
    }
}
